__turbopack_context__.v({
  "picture": "vSm2na_picture",
});
